require('./page_tab_navigation.coffee')
require('./interactive_window.coffee')
require("slick-carousel");


class window.HomePage
  constructor: ->
    @init()

  init: ->
    window.interactiveWindow = new window.InteractiveWindow($('#interactive-window__home'), 'animate-element--slow')
#    @catalogBlockInit()

  catalogBlockInit: ->
    $('.catalog-category-item').mouseenter ->
      if window.innerWidth > 1104
        activeElementIndex = $(this).data('categoryIndex')
        $('.catalog-category-item').addClass('catalog-category-item--not-selected')
        $(this).removeClass('catalog-category-item--not-selected')
        $(this).addClass('catalog-category-item--selected')

    $('.catalog-category-item').mouseleave ->
      $('.catalog-category-item').removeClass('catalog-category-item--not-selected')
      $('.catalog-category-item').removeClass('catalog-category-item--selected')


// WEBPACK FOOTER //
// ./assets/javascripts/app/home.coffee